export var ReviewStatus;
(function (ReviewStatus) {
    ReviewStatus["EXPIRED"] = "Expired";
    ReviewStatus["COMPLETED"] = "Completed";
    ReviewStatus["ACTIVATED"] = "Activated";
    ReviewStatus["PENDING"] = "Pending";
    ReviewStatus["NONE"] = "None";
})(ReviewStatus || (ReviewStatus = {}));
//# sourceMappingURL=review.js.map